import { BaseDto } from '@greco/util-dto';
import { Expose } from 'class-transformer';
import { IsNotEmpty, IsString } from 'class-validator';
export class CreateChildAccountDto extends BaseDto {
  @Expose()
  @IsString()
  @IsNotEmpty()
  displayName!: string;
}
